<template>
  <base-page>
    <el-card style="margin: 5px 0px 5px 0px">
      <el-collapse accordion style="border: none">
        <el-collapse-item name="1" style="border: none">
          <template slot="title">
            <div slot="header" class="clearfix">
              <titlu-pagina
                Titlu="Raport comenzi COMENZI nesosite/neasociate"
                @on_add_clicked="show_dialog()"
                :AdaugaVisible="false"
              />
            </div>
          </template>
          <div class="filtre">
            <el-form @submit.prevent.native="" size="small" label-position="top">
              <el-row :gutter="15">
                <el-col :md="8" :sm="12" :xs="24">
                  <el-form-item label="# Programare">
                    <el-input v-model="Filters.IdDeviz" size="small" clearable />
                  </el-form-item>
                </el-col>

                <el-col :md="8" :sm="12" :xs="24">
                  <el-form-item label='Interval'>
                    <el-date-picker
                        v-model="Filters.Data"
                        type="daterange" size="small"
                        range-separator="-"
                        start-placeholder="Data inceput"
                        end-placeholder="Data sfarsit"
                        :picker-options="datePickerOptions"
                        format="dd/MM/yyyy" value-format="yyyy-MM-dd" 
                        clearable>
                    </el-date-picker>
                  </el-form-item>
                </el-col>

                <el-col :md="8" :sm="12" :xs="24">
                  <el-form-item label="Numar inmatriculare">
                    <el-input v-model="Filters.Numar" size="small" clearable/>
                  </el-form-item>
                </el-col>

                <el-col :md="12" :sm="24">
                  <el-form-item label="Client">
                    <el-select size="small" class="full-width" 
                      placeholder="Cauta dupa nume, telefon sau email"
                      remote
                      ref="focusShow"
                      :remote-method="handleFindClient"
                      v-model="Filters.IdClient"
                      clearable
                      filterable>
                        <el-option
                          v-for="item in Info.clienti"
                          :key="'lista_clienti'+item.Id"
                          :id="'lista_clienti'"
                          :name="'Telefon: ' + item.Telefon + ' Email: '+ item.Email"
                        :label="'Client: ' + item.Nume + ' ' + item.Prenume"
                        :value="item.Id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

                <el-col :md="6" :sm="24">
                  <el-form-item label="Fara deviz">
                    <el-select style="width:100%" v-model="Filters.FaraDeviz" size="small" placeholder="Alege">
                      <el-option label="Toate" value=""></el-option>
                      <el-option label="Da" value="da"></el-option>
                      <el-option label="Nu" value="nu"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :md="6" :sm="24">
                  <el-form-item  label="Status rezervare">
                    <el-select style="width:100%" v-model="Filters.StatusRezervare" size="small" placeholder="Alege">
                      <el-option label="Toate" value=""></el-option>
                      <el-option label="Deschisa" value="Deschisa"></el-option>
                      <el-option label="Anulata" value="Anulata"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

                <el-col :md="24">
                  <el-button
                    type="primary"
                    native-type="submit"
                    @click="refresh_info()" size="small"
                  >
                    Aplica
                  </el-button>
                  <el-button type="danger" native-type="submit" @click="reset()" size="small">
                    Reseteaza
                  </el-button>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-collapse-item>
      </el-collapse>
    </el-card>

    <el-table :data="Results" size="mini" class="tabelRandMic" v-loading="tableLoading">
      <el-table-column prop="Id" label="# Programare"></el-table-column>
      <el-table-column prop="StatusRezervare" label="Status rezervare"></el-table-column>
      <el-table-column label="Data rezervarii">
        <template slot-scope="scope">
          {{ scope.row.DataRezervarii | DataOraFaraSec() }}
          <!-- {{ scope.row }} -->
        </template> 
      </el-table-column>
      <el-table-column prop="Numar" label="Numar"></el-table-column>
      <el-table-column prop="Client" label="Client"></el-table-column>
      <!-- <el-table-column prop="GradAsociere" label="Grad de asociere" :formatter="formatGradAsociere"></el-table-column> -->
      <el-table-column label="+" width="50px">
        <template slot-scope="scope">
          <!-- sa imi arata tooltip doar daca NU exista camp_adaugat sau nu e setat-->
          <el-tooltip v-if="typeof scope.row.camp_adaugat == 'undefined' || scope.row.camp_adaugat=='false'" content="Adauga comanda">
            <i class="el-icon-plus"  style="color:green" @click="adauga_comanda(scope.row)"></i>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="Comenzi" width="555px"  align="center">
        <template slot-scope="scope">
          <el-table border :data="scope.row.comenzi" size="mini" class="tabelRandMic" style="color:darkblue;">
            <el-table-column label="Status" width="180px">
              <template slot-scope="scope">
                {{ scope.row.Status | Frumos}}
                <el-tooltip  v-if="scope.row.Id > 0" content="Reverifica status in EVIO">
                  <i class="el-icon-refresh"  style="color:green" @click="verifica_comanda(scope.row)"></i>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="Nr. comanda" width="140px">
              <template slot-scope="scope">
                <div v-if="scope.row.modEdit == 'false'">
                  <span>{{ scope.row.NumarComanda }}</span>&nbsp;
                  <el-tooltip content="Modifica">
                    <i class="el-icon-edit"  style="color:red" @click="modifica_comanda(scope.row)"></i>
                  </el-tooltip>
                </div>
                <div v-else>
                    <el-input-number :controls="false" :min="1" v-model="scope.row.NumarComanda" size="mini" style="width:60% !important" @keyup.native.enter="schimba_comanda(scope.row)"/>
                  &nbsp;
                  <el-tooltip content="Accepta">
                    <i class="el-icon-check"  style="color:green" @click="schimba_comanda(scope.row)"></i>
                  </el-tooltip>
                </div>
                
              </template>
            </el-table-column>
            <el-table-column label="Grad asociere" width="130px">
              <template slot-scope="childScope">
                {{ formatGradAsociere(childScope.row) }}
              </template>
            </el-table-column>
            <el-table-column label="Ultima verif." width="140px">
              <template slot-scope="scope">
                {{ scope.row.DataStatus | DataOraFaraSec}}
              </template>
            </el-table-column>
            <el-table-column label="Actiuni" width="100px" fixed="right" align="right">
              <template slot-scope="scope">
                <el-tooltip  v-if="scope.row.Id > 0" content="Sterge">
                  <el-button size="mini"
                  style="padding: 2px;"
                    class="butonReg"
                    type="danger"
                    icon="el-icon-minus"
                    circle
                    @click="sterge_comanda(scope.row)"
                    />
                </el-tooltip>
                <el-tooltip  v-if="scope.row.Id > 0" content="History">
                  <el-button size="mini"
                  style="padding: 2px;"
                    class="butonReg"
                    type="info"
                    circle
                    @click="preview_history(scope.row.NumarComanda)">
                    H
                  </el-button>
                </el-tooltip>
                <el-tooltip v-if="!scope.row.Asocieri || scope.row.Asocieri != 'asociata'" content="Asociaza manual comanda">
                  <el-button size="mini"
                    style="padding: 2px;"
                    class="butonReg"
                    type="warning"
                    icon="el-icon-link"
                    circle
                    @click="asociaza_comanda(scope.row)"
                  />
                </el-tooltip>
              </template>
            </el-table-column>

          </el-table>
    

        </template> 
      </el-table-column>

      <el-table-column label="Actiuni"  width="10px" fixed="right" align="right">
        <el-button size="mini"
          class="butonReg"
          type="success"
          icon="el-icon-refresh"
          circle
          @click="alert(scope.row)"
          />
      </el-table-column>
    </el-table>

    <el-pagination
      @size-change="refresh_info"
      @current-change="refresh_info"
      :page-size.sync="PaginationInfo.PerPage"
      :current-page.sync="PaginationInfo.Page"
      :total="PaginationInfo.RowCount"
      layout="pager"
    />
    <Preview-history ref="dlg_history" />
  </base-page>
</template>

<script>
import settings from "@/backend/LocalSettings";
import BasePage from "@/pages/Admin/BasePage";
import TitluPagina from "@/widgets/TitluPagina";
import Preview_history from './Preview_history.vue';

export default {
  name: "raport_anulari",
  extends: BasePage,
  components: {
    "base-page": BasePage,
    "titlu-pagina": TitluPagina,
    "Preview-history": Preview_history,
  },
  data() {
    return {
      tableLoading: false,
      datePickerOptions: settings.datePickerOptions,
      Results: [],
      refresh_interval: null,
      base_url: "",
      dateVechi: "",
      Info: {
        clienti: [],
      },
      Filters: {
        Data: [],
        Numar: "",
        IdClient: "",
        IdCentruProductie: "-1",
        IdDeviz: "",
        FaraDeviz: "da",
        StatusRezervare: "Deschisa",
      },
      OrderBy: {'Id': 'DESC'},
      PaginationInfo: {
        Page: 1,
        PerPage: 50,
        RowCount: 0,
        PageSizes: [10, 25, 50, 100, 200],
      },
    };
  },
  methods: {

    async asociaza_comanda(item) {
      console.log(item);
      this.$confirm("Esti sigur ca vrei sa marchezi aceasta comanda ca fiind asociata?", 'Confirmare asociere', {
        confirmButtonText: 'Da',
        cancelButtonText: 'Nu',
        type: 'warning'
      })
      .then(async () => {
        try {
          let raspuns = await this.post("admin/rapoarte/asociaza_comanda", { id: item.Id });
          if (raspuns.Success) {
            this.$message.success("Comanda a fost asociata cu succes!");
            await this.refresh_info();
          } else {
            this.$message.error(raspuns.ErrorMessage || "Eroare la asociere");
          }
        } catch (e) {
          console.error(e);
          this.$message.error("A aparut o eroare de comunicare.");
        }
      })
      .catch(() => {
        // Anulat de utilizator
      });
    },
    async get_info() {
      var response = await this.post("admin/raport_anulari/get_info");
      this.Info.centre_productie = response.centre_productie;
      this.refresh_info();
      this.handleIntervalChange();
    },

    async refresh_info_without_loader() {
      var response = await this.post("admin/rapoarte/index_raport_hotel_nesosite", {
        Filters: this.Filters,
        OrderBy: this.OrderBy,
        PaginationInfo: this.PaginationInfo,
      });
      if(typeof response.Results != 'undefined') {
        if (this.dateVechi != '' && JSON.stringify(response.Results) == this.dateVechi) {
          console.log('nu s-a schimbat nimic in comenzi')
        } else {
          this.Results        = response.Results;
          this.dateVechi = JSON.stringify(response.Results);
        }
      }
    },
    async refresh_info() {
      var response = await this.post("admin/rapoarte/index_raport_hotel_nesosite", {
        Filters: this.Filters,
        OrderBy: this.OrderBy,
        PaginationInfo: this.PaginationInfo,
      });
      this.Results = response.Results;
      this.PaginationInfo = response.PaginationInfo;
      this.dateVechi = JSON.stringify(this.Results)

      //
      this.select_menu_item("actiuni");
    },
    reset() {
      this.Filters = {
        Data: [],
        Numar: "",
        IdClient: "",
        IdDeviz: "",
        IdCentruProductie: "-1",
      };
      this.refresh_info();
    },
    async handleFindClient(data) {
      await new Promise(resolve => setTimeout(resolve, 200)); 
      var result = await this.post("admin/rapoarte/remoteFindClient", { search: data});
      if(result){
        this.Info.clienti = result.clienti;
      }
    },
    async handleIntervalChange() {
      if (this.$route.name != 'raport_comenzi_neasociate') {
        return;
      }
      if (this.refresh_interval) {
        clearInterval(this.refresh_interval);
        this.refresh_interval = null;
      }
      this.refresh_info_without_loader();
      this.refresh_interval = setInterval(() => {
        if (this.$route.name == 'raport_comenzi_neasociate') {
          this.refresh_info_without_loader();
        }
      }, 10000);
    },
    show_dialog(id) {
      this.$refs.dlg.show_me(id);
    },
    modifica_comanda(rand) {
      console.log(rand);
      rand.modEdit = "true";
    },
    async verifica_comanda(item) {
      this.tableLoading = true;
      try {
        const raspuns = await this.post("admin/rapoarte/verifica_comanda", { id: item.Id });
        if (!raspuns.ErrorMessage) {
          this.$message.success("Status actualizat");
          item.Status = raspuns.Date.StatusComanda;
          item.DataStatus = raspuns.Date.Data;
        } else {
          this.$message.error("Eroare: " + raspuns.ErrorMessage);
        }
      } catch (e) {
        console.error(e);
        this.$message.error("Eroare la verificare");
      } finally {
        this.tableLoading = false;
      }
    },
    async sterge_comanda(item) {
      this.$confirm("Aceasta comanda se va sterge", 'Atentie', {confirmButtonText: 'Da',cancelButtonText: 'Nu',type: 'warning'})
            .then(async () => {
              let raspuns = await this.post("admin/rapoarte/sterge_numar_comanda", { id: item.Id });
              if (raspuns.Success) {
                this.$message.success("Comanda stearsa");
                // se sterge comanda din rand
                let rezervare = this.Results.find(ceva => ceva.Id === item.IdRezervare);
                if (rezervare) {
                  let index = rezervare.comenzi.findIndex(x => x.Id === item.Id);
                  rezervare.comenzi.splice(index, 1);
                } else{
                  this.$message.error("Eroare");
                }
              } else {
                this.$message.error("Eroare");
              }
            })
            .catch(async () => {
              this.$message({type: 'info',message: 'Stergerea a fost anulata!'});});      
    },
    async preview_history(NrComanda) {
      this.$refs.dlg_history.show_me(NrComanda);
    },
    adauga_comanda(rand) {
      rand.camp_adaugat = "true";
      rand.comenzi.push({
        Id: 0,
        IdRezervare: rand.Id,
        Status: "",
        NumarComanda: "",
        DataStatus: "",
        modEdit: "true",
        camp_adaugat: "true",
      });
    },       
    async schimba_comanda(rand) {
      console.log(rand);  
      let rezervare = this.Results.find(item => item.Id === rand.IdRezervare);
      if (rezervare) {
        console.log(rezervare);
        let comanda = rezervare.comenzi.find(item => item.Id === rand.Id);
        console.log(comanda);
        let raspuns = await this.post("admin/rapoarte/modifica_numar_comanda", { rand: rand });
        if (raspuns.Success) {
          if(rezervare.camp_adaugat == "true"){
            this.$message.success("Comanda adaugata cu succes");
          } else {
            this.$message.success("Comanda modificata cu succes");
          }
          rand.modEdit = "false";
          rezervare.camp_adaugat = "false";
          if(raspuns.mode == 'add') rand.Id = raspuns.LastInsertedId;
          this.verifica_comanda(rand);
          comanda.modEdit = "false";
        } else {
          this.$message.error("Eroare");
        }
      }
    },   
    formatGradAsociere(row) {
      let val = row.Asocieri && row.Asocieri.trim() !== ''
        ? row.Asocieri
        : 'neasociata';
      return val.charAt(0).toUpperCase() + val.slice(1);
    },
  },
  mounted() {
    if (!this.$has_right('Management')){
      this.$router.push("/no-rights");
      return;
    }
    this.base_url = settings.BASE_URL;
    this.get_info();
    this.handleFindClient();
  },
  beforeDestroy() {
    if (this.refresh_interval) {
      clearInterval(this.refresh_interval);
    }
  },
};
</script>

<style lang="less" scoped>
.top50 {
  margin-top: 20px;
}

.filtre {
  .el-input-number {
    width: 100% !important;
  }
}

#lista_clienti:after {
  content: attr(name);
  width: auto;
  max-height: 27px !important;
  color: rgb(0, 0, 0);
  display: flex;
  justify-content: center;
  align-items: center;
  float: right;
  font-size: 12px !important;
  padding: 0 5px;
  margin: 2px 0;
  border: 1px solid transparent;
  border-radius: 7px;
  background-color: #d6dee5a1;
}
.input-element {
  width: 18%;
  margin-right: 2%;
}

@media only screen and (max-width: 600px) {
  .input-element {
    width: 80%;
  }

  .el-tooltip__popper {
    width: 90%;
  }
}
</style>
